module.exports = __webpack_public_path__ + "static/media/03.38a3a069.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/03.jpg
// module id = 565
// module chunks = 0